<template>                    
    
    <v-layout row>
        <v-flex xs5>
            <v-select                        
                label="Auswahl Marken"
                autocomplete
                v-bind:loading="loading"
                dark
                multiple
                cache-items
                chips
                required
                v-bind:items="marken"     
                item-text="name"
                item-value="id"
                return-object
                v-bind:search-input.sync="search"
                v-model="fa.marken"></v-select>
        </v-flex>

        <v-flex xs6 offset-xs1> 
            <v-layout row wrap>
                <v-flex xs6 v-for="(marke,index) in fa.marken" v-bind:key="index">
                    
                    <p>                        
                      <strong> {{ marke.name }} </strong>
                    </p>
                    <v-avatar tile>                            
                        <img v-bind:src="markenlogo(marke.logos[0].dateiserverpfad)" class="dragLogo">
                    </v-avatar>
                                                                
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
       

</template>

<script>

export default {
    
    data() {
        return {
                     
            search: null,          
        };
    },
    watch: {
      search (val) {
        val && this.querySelections(val)
      }
    },
    //created: function(){
//        this.$store.dispatch('setMarken')
//    },
    
    computed: {
        marken: function() {
            
            return this.$store.getters.marken
        },
        
        fa: function() {
            return this.$store.getters.firma
        },
        loading: function() {
            return this.$store.getters.loading
        },
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 
        
    },
    methods: {

        querySelections (v) {
            //this.loading = true               
            this.fa.marken = this.marken.filter(e => {
                    return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            })
            //this.loading = false
        
        },
        markenlogo: function(path) {
            return this.basePath + 'storage/logos/' + path;
        }
              
    }
}
    
</script>

<style>
    
    img.dragLogo {
        max-height: 40px;
        border-radius: 0%;
        max-width: 500px;
        width: auto;
    }
    
</style>


// WEBPACK FOOTER //
// markenSelect.vue?5cf8fa64